import styled from "styled-components";

export const DepoStyle = styled.section`
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    height: 100vh;
    background-color: #6098ab;
    @media (max-width: 768px) {
        flex-direction: column;
    }

    .card {
        overflow-y: auto,
        height: 50vh;
        padding: 20px;
        background-color: #6098ab; 
        border: none;
        @media (max-width: 768px) {
            margin-bottom: 15px;
        }
    }
    .form {
        margin-left: 100px;
        @media (max-width: 768px) {
            margin-left: 0px;
        }
    }

`